import type { Reference, Source } from '@netpurpose/types'
import type { Reference as BackendReference } from '../../generated/facts'
import { parseSource } from '../source'

export const parseReference = (reference: BackendReference): Reference => ({
  id: reference.reference_id,
  pageNumber: reference.page_num || undefined,
  source: (reference.source && parseSource(reference.source)) as Source,
})
